import { PLAYING_SOUND_END } from '../constants/actionTypes'

export const endPlayingSound = () => ({ type: PLAYING_SOUND_END })
